import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import AdminApp from './admin/AdminApp';
import Dashboard from './pages/Dashboard';
import Configuration from './pages/Configuration';
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import { AuthProvider } from './contexts/AuthContext';
import { NavigationProvider } from './contexts/NavigationContext';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Navigation from './components/Navigation';
import { HelmetProvider } from 'react-helmet-async';
import './firebase-config';

function App() {
  return (
    <HelmetProvider>
      <ChakraProvider>
        <ErrorBoundary>
          <Router>
            <AuthProvider>
              <NavigationProvider>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/faq" element={<FAQ />} />
                  
                  {/* Protected Routes */}
                  <Route 
                    path="/dashboard" 
                    element={
                      <PrivateRoute>
                        <>
                          <Navigation />
                          <Dashboard />
                        </>
                      </PrivateRoute>
                    }
                  />
                  <Route 
                    path="/admin/*" 
                    element={
                      <PrivateRoute>
                        <>
                          <Navigation />
                          <AdminApp />
                        </>
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </NavigationProvider>
            </AuthProvider>
          </Router>
        </ErrorBoundary>
      </ChakraProvider>
    </HelmetProvider>
  );
}

export default App;
